export enum WeddingEvent {
    welcomeDinner = 'welcomeDinner',
    wedding = 'wedding',
    afterParties = 'afterParties',
}